import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import StrategyConsultingPage from "@/pages/service/StrategyConsultingPage";

export const Route = createFileRoute("/service/strategy-consulting")({
  head: () => pageHead("Strategy Consulting", "Strategic business consulting with proven frameworks for organizational transformation and competitive positioning.", "/service/strategy-consulting", false),
  component: StrategyConsultingPage,
});
